import { AdminOrganizationAutoCompleteType } from 'api/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<AdminOrganizationAutoCompleteType>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationsParentAutoCompleteReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationsParentAutoComplete.request.type]: actionsHandlers.handleGetPaginatedManyRequest,
  [actions.getAdminOrganizationsParentAutoComplete.success.type]: actionsHandlers.handleGetPaginatedManySuccess,
  [actions.getAdminOrganizationsParentAutoComplete.failure.type]: actionsHandlers.handleGetPaginatedManyFailure,
  [actions.getAdminOrganizationsParentAutoComplete.reset.type]: actionsHandlers.handleGetPaginatedManyReset,
});

export default adminOrganizationsParentAutoCompleteReducer;
